/* eslint-disable import/prefer-default-export */
import * as req from 'api/actions';
import alert from 'react-s-alert';
import * as c from './constant';

export const getSettings = (payload = { sort_by: 'desc' }, callback) =>
  req.list(
    c.GET_SETTINGS,
    'api/v1/administrators/hospitals',
    payload,
    callback
  );

export const showUserManagement = (id, payload, callback) =>
  req.item(
    c.GET_SINGLE_SETTING,
    `api/v1/administrators/hospitals/${id}`,
    payload,
    callback
  );

export const createUserManagement = (payload, callback) =>
  req.create(
    c.CREATE_SETTING,
    'api/v1/administrators/hospitals',
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const updateUserManagement = (id, payload, callback) =>
  req.update(
    c.UPDATE_SETTING,
    `api/v1/administrators/hospitals/${id}`,
    payload,
    ({ res }) => {
      const { data } = res.res;
      if (callback) callback({ data });
    }
  );

export const removeSettings = (id, payload, callback) =>
  req.remove(
    c.REMOVE_SETTING,
    `api/v1/administrators/hospitals/${id}`,
    payload,
    (res) => {
      const { message } = res.res;
      alert.success(message || 'Successfully Remove !');
      if (callback) callback();
    }
  );

export const getRoleList = (
  payload = { is_paginated: 1, sort_by: 'desc' },
  callback
) =>
  req.list(c.GET_ROLE_LIST, 'api/v1/administrators/roles', payload, callback);
